import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AircraftDetailsView } from '@flight-details/aircraft/models/aircraft-details.view';
import { AircraftRoutingView } from '@flight-details/aircraft/models/aircraft-routing.view';
import { ArmedPaxView } from '@flight-details/armed-pax/models/armed-pax.view';
import { CrewListView } from '@flight-details/crew/models/view/crew-list.view';
import { CrewLocationView } from '@flight-details/crew/models/view/crew-location.view';
import { InboundFlightView } from '@flight-details/inbound-flight/models/inbound-flight.view';
import { KcmView } from '@flight-details/kcm/models/kcm.view';
import { LoadView } from '@flight-details/load/models/load.view';
import { InboundConnectionsView } from '@flight-details/pax-connections/inbound-connections/models/inbound-connections.view';
import { OutboundConnectionsView } from '@flight-details/pax-connections/outbound-connections/models/outbound-connections.view';
// import { ReleaseView } from '@flight-details/release/models/view/release.view';
import { Jumpseater } from '@flight-details/standby-list/models/jumpseater';
import { StandbyListView } from '@flight-details/standby-list/models/standby-list.view';
import { WeatherView } from '@flight-details/weather/models/weather.view';
import { SabreText } from '@shared/components/sabre-text-dialog/models/sabre-text';
import { ReservationResponse } from '@shared/features/hotel/models/response/reservation.response';
import { MelView } from '@shared/models/mel.view';
import { RequestState } from '@shared/models/request-state';
import { StationInfoView } from '@shared/services/station-info/models/station-info.view';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-save-all-dialog',
  templateUrl: './save-all-dialog.component.html',
  styleUrls: ['./save-all-dialog.component.scss'],
  standalone: false,
})
export class SaveAllDialogComponent {
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      kcmState$?: Observable<RequestState<KcmView>>;
      crewState$?: Observable<RequestState<CrewListView>>;
      crewLocationState$: Observable<RequestState<CrewLocationView>>;
      // releaseState$?: Observable<RequestState<ReleaseView>>;
      armedPaxState$?: Observable<RequestState<ArmedPaxView>>;
      weatherState$?: Observable<RequestState<WeatherView>>;
      inboundCrewListState$?: Observable<RequestState<CrewListView>>;
      inboundFlightStatusState$?: Observable<RequestState<InboundFlightView>>;
      aircraftDetailsState$?: Observable<RequestState<AircraftDetailsView>>;
      melsState$?: Observable<RequestState<MelView[]>>;
      aircraftRoutingState$?: Observable<RequestState<AircraftRoutingView>>;
      paxLoadState$?: Observable<RequestState<LoadView>>;
      standbyListState$: Observable<RequestState<StandbyListView>>;
      jumpseaters$: Observable<Jumpseater[]>;
      jumpseatersIsLoading$: Observable<boolean>;
      hotelState$: Observable<RequestState<ReservationResponse>>;
      depFieldReport$: Observable<RequestState<SabreText>>;
      arrFieldReport$: Observable<RequestState<SabreText>>;
      depStationInfoState$: Observable<RequestState<StationInfoView>>;
      arrStationInfoState$: Observable<RequestState<StationInfoView>>;
      inboundConnectionsState$: Observable<
        RequestState<InboundConnectionsView>
      >;
      outboundConnectionsState$: Observable<
        RequestState<OutboundConnectionsView>
      >;
    },
  ) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
